import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { Observable, from } from "rxjs";
import { Injectable } from "@angular/core";
import { AuthService } from "@dmms/core/auth";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    public readonly dialog: MatDialog,
    private readonly authService: AuthService,
    public readonly router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    if (this.dialog.openDialogs.length > 0) {
      this.dialog.closeAll();
    }

    return from(this.checkAccess(route, state));
  }

  private async checkAccess(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    const isSignedIn = await this.authService.isUserSignedIn();
    if (!isSignedIn) {
      return this.redirectToLoginSync(state);
    }

    const requiredRoles = route.data["roles"] as string[] | undefined;
    if (!requiredRoles || !requiredRoles.length) {
      return true;
    }
    const userRoles = await this.authService.getUserRoles();
    const hasRole = userRoles
      ? requiredRoles.some((r) => userRoles.includes(r))
      : false;
    return hasRole ? true : this.redirectToAccessDenied();
  }

  private redirectToLoginSync(state: RouterStateSnapshot): UrlTree {
    return this.router.createUrlTree(["auth"], {
      queryParams: { returnUrl: state.url },
    });
  }

  redirectToAccessDenied(): UrlTree {
    return this.router.createUrlTree(["/access-denied"]);
  }
}
